const { NODE_ENV = '' } = process.env;

const environment = NODE_ENV.toLowerCase();

export { environment };
